import _ from 'lodash'
import { ActionTypes } from '../../constants'
import { Student } from '@app/models/users'

const processDiplomas = (action) => {
  return _
    .chain(action.diplomas)
    .map((result) => _.update(result, 'student', () => new Student(result.student)))
    .sortBy('student.fullName')
    .value()
}

const diplomas = (state = {
  object: null,
  fetching: false,
  error: null,
  updatedOn: null,
  didInvalidate: false
}, action) => {
  switch(action.type) {

  case ActionTypes.CHILDREN_DIPLOMAS_REQUEST:
  case ActionTypes.CLASS_DIPLOMAS_REQUEST:
    return { ...state, fetching: true, error: null }

  case ActionTypes.CHILDREN_DIPLOMAS_RECEIVING_SUCCESS:
  case ActionTypes.CLASS_DIPLOMAS_RECEIVING_SUCCESS:
    return {
      ...state,
      fetching: false,
      updatedOn: action.updatedOn,
      object: processDiplomas(action),
      didInvalidate: false
    }

  case ActionTypes.CHILDREN_DIPLOMAS_RECEIVING_FAILURE:
  case ActionTypes.CLASS_DIPLOMAS_RECEIVING_FAILURE:
    return {
      ...state,
      fetching: false,
      error: action.error,
      didInvalidate: true
    }

  default:
    return state
  }
}

export default diplomas
